// import React from 'react'

// function Home() {
//   return (
//     <div>
//       <section class="ak-slider ak-slider-hero ak-slider-hero-1">
//         <div class="swiper-wrapper">
//             <div class="swiper-slide">
//                 <div class="ak-hero ak-style1 slide-inner" data-swiper-parallax="100%">
//                     <div class="ak-hero-featured" data-src="./assets/img/bg/bgh31.png">
//                         <img src="./assets/img/bg/bgh31.png" class="ak-hero-bg" alt="..." />
//                         {/* <img src="./assets/img/service/c12.png" class="ak-hero-bg" alt="..." /> */}
//                     </div>
//                     <div class="container-md">
//                         <div class="hero-slider-info">
//                             <div class="slider-info">
//                                 <div class="hero-title" >
//                                     <p class="mini-title" style={{color:'white'}}>
//                                     Welcome to Your Trusted Semantic Partner!
//                                     </p>
//                                     <h6 class="hero-main-title responive_na" >
//                                         Expert Guidance From <br/>
//                                         <span class="hero-main-title-1 style-2" style={{fontSize:'68px',color:'white'}}>
//                         Our Trusted Talent Partner</span
//                       >
//                     </h6>
//                     {/* <h6 class="hero-main-title" style{{font-size="16px; line-height: 1.5;"}}>
//     Expert Guidance from <br/>
//     <span class="hero-main-title-1 style-2" style="font-size: 14px;">
//         Our Trusted Talent Partner
//     </span>
// </h6> */}
//                     <p class="main-desp" style={{color:'white'}}>
//                     Building India’s future as a global semiconductor leader through hands-on,
//                     industry-aligned training.
//                     </p>
//                   </div>
//                   <div class="ak-height-50 ak-height-lg-40"></div>
//                   <div>
//                     <a href="/contact" class="common-btn style-2">
//                       <span>Free Consultation</span>
//                                         <span class="arrow-cricle">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="10"
//                           height="10"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M0.828613 5H9.16195M9.16195 5L5.16195 1M9.16195 5L5.16195 9"
//                             stroke="#030917"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="10"
//                           height="10"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M0.828613 5H9.16195M9.16195 5L5.16195 1M9.16195 5L5.16195 9"
//                             stroke="#030917"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                       </span>
//                                         </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div class="swiper-slide">
//                 {/* <div class="ak-hero ak-style1 slide-inner" data-swiper-parallax="100%">
//                     <div class="ak-hero-featured" data-src="assets/img/hero/hero_1.png">
//                         <img src="./assets/img/hero/hero_2.png" class="ak-hero-bg" alt="..." />
//                     </div>
//                     <div class="container-md">
//                         <div class="hero-slider-info">
//                             <div class="slider-info">
//                                 <div class="hero-title">
//                                     <p class="mini-title">
//                                         Welcome to Your Trusted Semantic Partner!
//                                     </p>
//                                     <h2 class="hero-main-title">
//                                         Expert Guidance from
//                                         <span class="hero-main-title-1 style-2">
//                         Our Trusted Talent Partner</span
//                       >
//                     </h2>
//                     <p class="main-desp">
//                     Building India’s future as a global semiconductor leader through hands-on, industry-aligned training.
//                     </p>
//                   </div>
//                   <div class="ak-height-50 ak-height-lg-40"></div>
//                   <div>
//                     <a href="about.html" class="common-btn style-2">
//                       <span>Free Consultation</span>
//                                         <span class="arrow-cricle">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="10"
//                           height="10"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M0.828613 5H9.16195M9.16195 5L5.16195 1M9.16195 5L5.16195 9"
//                             stroke="#030917"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="10"
//                           height="10"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M0.828613 5H9.16195M9.16195 5L5.16195 1M9.16195 5L5.16195 9"
//                             stroke="#030917"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                       </span>
//                                         </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div> */}
//             </div>
//             {/* <div class="swiper-slide">
//                 <div class="ak-hero ak-style1 slide-inner" data-swiper-parallax="100%">
//                     <div class="ak-hero-featured" data-src="assets/img/hero/hero_1.png">
//                         <img src="assets/img/hero/hero_3.png" class="ak-hero-bg" alt="..." />
//                     </div>
//                     <div class="container-md">
//                         <div class="hero-slider-info">
//                             <div class="slider-info">
//                                 <div class="hero-title">
//                                     <p class="mini-title">
//                                         Welcome to Your Trusted Financial Partner!
//                                     </p>
//                                     <h2 class="hero-main-title">
//                                         Expert Guidance from <br/>
//                                         <span class="hero-main-title-1 style-2">
//                         Our Trusted Advisors</span
//                       >
//                     </h2>
//                     <p class="main-desp">
//                       Empowering Your Financial Future Expert Guidance from
//                       Trusted Advisors. Lorem ipsum is simply dummy text.
//                     </p>
//                   </div>
//                   <div class="ak-height-50 ak-height-lg-40"></div>
//                   <div>
//                     <a href="contact.html" class="common-btn style-2">
//                       <span>Free Consultation</span>
//                                         <span class="arrow-cricle">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="10"
//                           height="10"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M0.828613 5H9.16195M9.16195 5L5.16195 1M9.16195 5L5.16195 9"
//                             stroke="#030917"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="10"
//                           height="10"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M0.828613 5H9.16195M9.16195 5L5.16195 1M9.16195 5L5.16195 9"
//                             stroke="#030917"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                           />
//                         </svg>
//                       </span>
//                                         </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}
//         </div>
//         <div class="social-hero">
//     <div class="content">
//         <h6 class="email style-1">(+91)7619617023</h6>

//          <div class="hr style-1" style={{    marginTop: "10px",
//     marginBottom:" 40px"}}></div>
//         <h6 class="email style-1">sriram@semanticskills.com</h6>
//     </div>
// </div>
//     </section>
//     {/* about */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
//     <div class="moving-section-wrap cs-bold">
//         <div class="moving-section-in">
//             <div class="moving-section">
//                 <h2 style={{fontSize:'34px'}}>
//                 Empowering Your Career Path
//                 Expert Training from Industry Leaders--
//                 </h2>
//             </div> 
//             <div class="moving-section">
//                 <h2 style={{fontSize:'34px'}}>
//                 Empowering Your Career Path
//                 Expert Training from Industry Leaders--
//                 </h2>
//             </div>
//             <div class="moving-section">
//                 <h2 style={{fontSize:'34px'}}>
//                 Empowering Your Career Path
//                 Expert Training from Industry Leaders--
//                 </h2>
//             </div>
//         </div>
//     </div>
//     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
//     <section class="container" style={{marginTop:'30px'}}>
//         <div class="about-us-content">
//             <div class="image-content">
//                 <img class="about-img-1" src="./assets/img/bg/hm3.png" alt="..." />

//             </div>
//             <div class="info-content" >
//                 <div class="ak-section-heading ak-style-1 animation-title-content animation-style3" style={{marginLeft:'-10px'}}>
//                     <p class="ak-section-subtitle animation-title">About Us</p>
//                     <h2 class="ak-section-title animation-title">
//                     Unlocking Global Talent Potential with Expert Training
//                     </h2>
//                     <p class="ak-section-desp" style={{textAlign:'justify'}}>
//                     At Semantic, we provide personalized training programs tailored to your unique career aspirations and the evolving needs of the semiconductor industry.
//                     </p>
//                     <p class="ak-section-desp" style={{textAlign:'justify'}}>
//                     With over 100 years of collective experience in the semiconductor industry, including 17 years spent at top international manufacturing plants, our leadership team brings unparalleled expertise to shape the future of global talent
//                     </p>
//                 </div>
//                 <br/>
//                 <div>
//                 <ul class="points-list" style={{textAlign:'justify'}}>
//         <li><strong>Tailored Programs:</strong> Custom training paths to suit individual career goals.</li>
//         <li><strong>Industry Expertise:</strong> Leadership team with decades of experience at leading global manufacturing plants.</li>
//         <li><strong>Real-World Skills:</strong> Training designed to equip professionals with skills for the evolving semiconductor industry.</li>
//     </ul>
//     </div>
//                 {/* <div class="day-time">
//                     <div class="ak-height-70 ak-height-lg-10"></div>
//                     <p class="text-uppercase ak-font-18 ak-black-color ak-medium mb-2">
//                         SATURDAY: 8 AM – 10 PM
//                     </p>
//                     <p class="text-uppercase ak-font-18 ak-black-color ak-medium">
//                         MON-FRI: 8 AM – 10 PM
//                     </p>
//                     <div class="ak-height-50 ak-height-lg-30"></div>
//                     <a href="about.html" class="common-btn">
//               <span> Get Started</span>
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="15"
//                   height="15"
//                   viewBox="0 0 15 15"
//                   fill="none"
//                 >
//                   <g clip-path="url(#clip0_201_978353)">
//                     <path
//                       d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                       stroke="#030917"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_201_978353">
//                       <rect
//                         width="14"
//                         height="14"
//                         fill="white"
//                         transform="translate(0.00927734)"
//                       />
//                     </clipPath>
//                   </defs>
//                 </svg>
//               </span>
//             </a>
//                 </div> */}
//             </div>
//         </div>
//     </section>
// {/* feature */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
//     <section class="container" style={{marginTop:"30px"}}>
//         <div class="feature-content">
//             <div class="feature-card">
//                 <img class="feature-icon" src="assets/img/icon/light.svg" alt="..." />
//                 <div class="feature-body">
//                     <h5 class="feature-title">Personalized Training Programs</h5>
//                     <p class="feature-desp" style={{textAlign:'justify'}}>
//                     Semantic offers the customized training programs carefully designed to help individuals
//                      achieve their career aspirations in the semiconductor industry, 
//                     ensuring they are equipped with the knowledge and skills required for success.
//                     </p>
//                     <a href="#" class="more-btn">
//               <span>Learn More</span>
//               <span class="svg-icon">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="18"
//                   height="19"
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                     fill="#030917"
//                   />
//                   <path
//                     d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="18"
//                   height="19"
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                     fill="#030917"
//                   />
//                   <path
//                     d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </span>
//             </a>
//                 </div>
//             </div>
//             <div class="ak-feature-hr"></div>
//             <div class="feature-card">
//                 <img class="feature-icon" src="assets/img/icon/hand.svg" alt="..." />
//                 <div class="feature-body">
//                     <h5 class="feature-title">Industry-Relevant Skill Development</h5>
//                     <p class="feature-desp" style={{textAlign:'justify'}}>
//                     Our programs emphasize the real-world applications, enabling professionals to acquire practical, hands-on skills that 
//                     align with the dynamic demands of the rapidly evolving semiconductor industry.
//                     </p>
//                     <a href="#" class="more-btn">
//               <span>Learn More</span>
//               <span class="svg-icon">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="18"
//                   height="19"
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                     fill="#030917"
//                   />
//                   <path
//                     d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="18"
//                   height="19"
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                     fill="#030917"
//                   />
//                   <path
//                     d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </span>
//             </a>
//                 </div>
//             </div>
//             <div class="ak-feature-hr"></div>
//             <div class="feature-card">
//                 <img class="feature-icon" src="assets/img/icon/note.svg" alt="..." />
//                 <div class="feature-body">
//                     <h5 class="feature-title">
//                     Clear Pathways to Career Growth
//                     </h5>
//                     <p class="feature-desp" style={{textAlign:'justify'}}>
//                     We provide the structured career development plans and offering step-by-step guidance to professionals, 
//                     helping them achieve sustainable growth and long-term success in the semiconductor domain.
//                     </p>
//                     <a href="#" class="more-btn">
//               <span>Learn More</span>
//               <span class="svg-icon">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="18"
//                   height="19"
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                     fill="#030917"
//                   />
//                   <path
//                     d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="18"
//                   height="19"
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                     fill="#030917"
//                   />
//                   <path
//                     d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </span>
//             </a>
//                 </div>
//             </div>
//         </div>
//     </section>

//     {/* <!-- Start Service --> */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
//     <section>
//         <div class="container">
//             <div class="service-top">
//                 <div class="ak-section-heading ak-style-1 animation-title-content animation-style3 ">
//                     <p class="ak-section-subtitle animation-title" style={{marginTop:'20px'}}>Services</p>
//                     <h4 class="ak-section-title animation-title" style={{fontSize:'40px'}}>
//                     Shaping the Future of Global Semiconductor Talent and Innovative Industry Solutions
//                     </h4>
//                 </div>
//                 <div class="service-swiper-controller" style={{marginLeft:'1100px',marginTop:'-40px'}}>
//                     <button class="service-next-btn slider-btn next">
//               <svg
//                 width="10"
//                 height="18"
//                 viewBox="0 0 10 18"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
//                   stroke="#030917"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                 />
//               </svg>
//             </button>
//                     <button class="service-prev-btn slider-btn prev">
//               <svg
//                 width="10"
//                 height="18"
//                 viewBox="0 0 10 18"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
//                   stroke="#030917"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                 />
//               </svg>
//             </button>
//                 </div>
//             </div>
//         </div>
//         <div class="ak-height-60 ak-height-lg-50"></div>
//         <div class="service-bg">
//             <div class="ak-white-bg-service"></div>
//             <div class="container">
//                 <div class="ak-slider ak-slider-service">
//                     <div class="swiper-wrapper">
//                         <div class="swiper-slide">
//                             <div class="service-card h-100">
//                                 <a href="/" class="service-thumb">
//                     <img src="./assets/img/bg/hmd.png" alt="..." />
//                     <div class="overlay-image">
//                       <img src="./assets/img/bg/hmd.png" alt="..." />
//                     </div>
//                   </a>
//                                 <div class="service-info">
//                                     <a href="/" class="service-title">
//                                     Design Solutions
//                     </a>
//                                     <p class="service-desp" style={{textAlign:'justify'}}>
//                                     This service focuses on innovative design solutions tailored 
//                                     to meet the specific requirements of projects. It emphasizes creativity, precision,
//                                      and user-centered approaches to deliver outstanding results.
//                                     </p>
//                                 </div>
//                                 {/* <div class="service-footer">
//                                     <a href="/" class="common-btn style-2 color-2">
//                       <span>Read More</span>
//                       <span class="arrow-cricle">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="15"
//                           height="15"
//                           viewBox="0 0 15 15"
//                           fill="none"
//                         >
//                           <g clip-path="url(#clip0_201_97878432)">
//                             <path
//                               d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                               stroke="#030917"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </g>
//                           <defs>
//                             <clipPath id="clip0_201_97878432">
//                               <rect
//                                 width="14"
//                                 height="14"
//                                 fill="white"
//                                 transform="translate(0.00927734)"
//                               />
//                             </clipPath>
//                           </defs>
//                         </svg>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="15"
//                           height="15"
//                           viewBox="0 0 15 15"
//                           fill="none"
//                         >
//                           <g clip-path="url(#clip0_201_97812313)">
//                             <path
//                               d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                               stroke="#030917"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </g>
//                           <defs>
//                             <clipPath id="clip0_201_97812313">
//                               <rect
//                                 width="14"
//                                 height="14"
//                                 fill="white"
//                                 transform="translate(0.00927734)"
//                               />
//                             </clipPath>
//                           </defs>
//                         </svg>
//                       </span>
//                     </a>
//                                 </div> */}
//                             </div>
//                         </div>
//                         <div class="swiper-slide">
//                             <div class="service-card h-100">
//                                 <a href="/" class="service-thumb">
//                     <img src="./assets/img/service/service_2.png" alt="..." />
//                     <div class="overlay-image">
//                       <img src="./assets/img/service/service_2.png" alt="..." />
//                     </div>
//                   </a>
//                                 <div class="service-info">
//                                     <a href="/" class="service-title"> Leadership Growth</a
//                     >
//                     <p class="service-desp" style={{textAlign:'justify'}}>
//                     This service is aimed at cultivating strong leadership qualities and strategies to
//                      drive organizational growth and success. Leadership training and consultation are tailored 
//                      to empower teams and individuals alike.
//                     </p>
//                   </div>
//                   {/* <div class="service-footer">
//                     <a
//                       href="/"
//                       class="common-btn style-2 color-2"
//                     >
//                       <span>Read More</span>
//                       <span class="arrow-cricle">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="15"
//                           height="15"
//                           viewBox="0 0 15 15"
//                           fill="none"
//                         >
//                           <g clip-path="url(#clip0_201_9789087)">
//                             <path
//                               d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                               stroke="#030917"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </g>
//                           <defs>
//                             <clipPath id="clip0_201_9789087">
//                               <rect
//                                 width="14"
//                                 height="14"
//                                 fill="white"
//                                 transform="translate(0.00927734)"
//                               />
//                             </clipPath>
//                           </defs>
//                         </svg>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="15"
//                           height="15"
//                           viewBox="0 0 15 15"
//                           fill="none"
//                         >
//                           <g clip-path="url(#clip0_201_978369)">
//                             <path
//                               d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                               stroke="#030917"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </g>
//                           <defs>
//                             <clipPath id="clip0_201_978369">
//                               <rect
//                                 width="14"
//                                 height="14"
//                                 fill="white"
//                                 transform="translate(0.00927734)"
//                               />
//                             </clipPath>
//                           </defs>
//                         </svg>
//                       </span>
//                     </a>
//                                 </div> */}
//                             </div>
//                         </div>
//                         <div class="swiper-slide">
//                             <div class="service-card h-100">
//                                 <a href="/" class="service-thumb">
//                     <img src="./assets/img/bg/hm5.png" alt="..." />
//                     <div class="overlay-image">
//                       <img src="./assets/img/bg/hm5.png" alt="..." />
//                     </div>
//                   </a>
//                                 <div class="service-info">
//                                     <a href="/" class="service-title">Manufacturing Excellence</a
//                     >
//                     <p class="service-desp" style={{textAlign:'justify'}}>
//                     This service involves leveraging advanced manufacturing techniques and strategies 
//                     to meet the evolving demands of clients. 
//                     The focus is on innovation and quality assurance to ensure exceptional results.
//                     </p>
//                   </div>
//                   {/* <div class="service-footer">
//                     <a
//                       href="/"
//                       class="common-btn style-2 color-2"
//                     >
//                       <span>Read More</span>
//                       <span class="arrow-cricle">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="15"
//                           height="15"
//                           viewBox="0 0 15 15"
//                           fill="none"
//                         >
//                           <g clip-path="url(#clip0_201_9782130)">
//                             <path
//                               d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                               stroke="#030917"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </g>
//                           <defs>
//                             <clipPath id="clip0_201_9782130">
//                               <rect
//                                 width="14"
//                                 height="14"
//                                 fill="white"
//                                 transform="translate(0.00927734)"
//                               />
//                             </clipPath>
//                           </defs>
//                         </svg>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="15"
//                           height="15"
//                           viewBox="0 0 15 15"
//                           fill="none"
//                         >
//                           <g clip-path="url(#clip0_201_9781476)">
//                             <path
//                               d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                               stroke="#030917"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </g>
//                           <defs>
//                             <clipPath id="clip0_201_9781476">
//                               <rect
//                                 width="14"
//                                 height="14"
//                                 fill="white"
//                                 transform="translate(0.00927734)"
//                               />
//                             </clipPath>
//                           </defs>
//                         </svg>
//                       </span>
//                     </a>
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 {/* <div class="ak-height-100 ak-height-lg-50"></div> */}
//                 <div class="ak-border-width"></div>
//                 <div class="ak-slider ak-slider-client-logo">
//                     <div class="swiper-wrapper">
//                         <div class="swiper-slide">
//                             <img src="./assets/img/clientLogo/log_1.png" alt="..." />
//                         </div>
//                         <div class="swiper-slide">
//                             <img src="./assets/img/clientLogo/log_2.png" alt="..." />
//                         </div>
//                         <div class="swiper-slide">
//                             <img src="./assets/img/clientLogo/log_3.png" alt="..." />
//                         </div>
//                         <div class="swiper-slide">
//                             <img src="./assets/img/clientLogo/log_4.png" alt="..." />
//                         </div>
//                         <div class="swiper-slide">
//                             <img src="./assets/img/clientLogo/log_1.png" alt="..." />
//                         </div>
//                         <div class="swiper-slide">
//                             <img src="./assets/img/clientLogo/log_2.png" alt="..." />
//                         </div>
//                     </div>
//                 </div>
//                 <div class="ak-border-width"></div>
//                 <div class="ak-height-50 ak-height-lg-50"></div>
//             </div>
//         </div>
//     </section>
//     {/* <!-- End Service --> */}

//     {/* <!-- Start Testmonial --> */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
//     <section>
//         <div class="container">
//             <div class="testmonial-top-content" style={{ display:'block'}}>
//                 <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
//                     {/* <p class="ak-section-subtitle animation-title" style={{marginTop:'20px'}}></p> */}
//                     <h4 class="ak-section-title animation-title" style={{fontSize:'35px',marginTop:'25px'}}>
//                     Enabling Taiwan-Based Support to Grow India's Semiconductor & ESDM Ecosystem Trusted Advisory and Mentorship in ESDM
//                     </h4>
//                 </div>
//                 <div style={{marginTop:'15px',fontSize:'20px'}}>
//                 {/* Enabling Taiwan-Based Support to Grow India's Semiconductor & ESDM Ecosystem. */}
//                 We provide specialized advisory and mentorship services to help grow India's semiconductor and ESDM (Electronic System Design and Manufacturing) ecosystem by leveraging our expertise and Taiwan-based support.
//                 </div>
//             </div>
//             {/* <div class="ak-height-60 ak-height-lg-50"></div> */}
//             <div class="testmonial-content ak-slider ak-slider-testmonial" style={{marginTop:'20px'}}>
//                 <div class="swiper-wrapper">
//                     <div class="swiper-slide">
//                         <div class="testmonial-slider">
//                             <div class="testmonial-img">
//                                 <img src="./assets/img/bg/hmc.png" data-swiper-parallax="200" alt="..." />
//                             </div>
//                             <div class="testmonial-info">
//                                 <p class="testmonial-shot-title">
//                                 Trusted Advisory and Mentorship in ESDM
//                                 </p>
//                                 <div class="ak-height-40 ak-height-lg-30"></div>
//                                 <section class="slide">
//   <h3>Pilot Plant Setup and Process Setup</h3>

//   <h4 style={{marginTop:'10px',marginLeft:'20px',lineHeight: '1.5'}}>Pilot Plant Setup</h4>
//   <ul style={{marginLeft:'30px'}}>
//     <li>Cleanroom establishment</li>
//     <li>Equipment identification & installation</li>
//     <li>Process qualification</li>
//   </ul>

//   <h4 style={{marginTop:'10px',marginLeft:'20px',lineHeight: '1.5'}}>Process Setup & Technology Transfers</h4>
//   <ul  style={{marginLeft:'30px'}}>
//     <li>Wafer Fab setup</li>
//     <li>OSAT/ATMP technology transfer</li>
//   </ul>
// </section>
//                                 {/* <h3 class="testmonial-title" style={{fontSize:'25px'}}>
//                                 The Pilot Plant Setup involves the establishment of cleanroom facilities, identifying and installing the necessary equipment, and conducting process qualification to ensure the proper functioning of the setup. In the Process Setup & Technology Transfers phase, we focus on the seamless establishment of Wafer Fab systems and the transfer of technology for OSAT/ATMP processes, ensuring efficient and effective integration of advanced semiconductor manufacturing capabilities.
//                                 </h3>
//                                 <div class="ak-height-50 ak-height-lg-30"></div> */}
//                                 {/* <div class="person-info">
//                                     <div>
//                                         <p class="name">Andrew Taylor</p>
//                                         <p class="form">From USA</p>
//                                     </div>
//                                     <div>
//                                         <svg xmlns="http://www.w3.org/2000/svg" width="43" height="38" viewBox="0 0 43 38" fill="none">
//                         <path
//                           d="M19.2291 14.229C19.2291 20.8709 17.6233 26.0703 14.4117 29.8272C11.2 33.5841 6.68822 36.0531 0.876244 37.2343V30.4171C5.28972 29.064 8.25971 26.6176 9.7862 23.078C10.6236 21.3935 10.9863 19.5127 10.8351 17.6376H0.548283L0.548283 0.39867L19.2291 0.39867V14.229ZM42.9883 14.229C42.9883 20.7836 41.4261 25.962 38.3018 29.7642C35.1775 33.5664 30.6221 36.0571 24.6354 37.2363V30.4191C29.0929 29.0193 32.0862 26.6159 33.6154 23.209C34.3942 21.4604 34.7318 19.5472 34.5983 17.6376L24.3075 17.6376V0.39867H42.9883L42.9883 14.229Z"
//                           fill="#485B60"
//                         />
//                       </svg>
//                                     </div>
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>
//                     <div class="swiper-slide">
//                         <div class="testmonial-slider">
//                             <div class="testmonial-img">
//                                 <img src="./assets/img/bg/hc.jpg" data-swiper-parallax="200" alt="..." />
//                             </div>
//                             <div class="testmonial-info">
//                                 <p class="testmonial-shot-title">
//                                 Trusted Advisory and Mentorship in ESDM
//                                 </p>
//                                 <div class="ak-height-40 ak-height-lg-30"></div>
//                                 <section class="slide">
//   <h3>Quality Management and Continuous Improvement</h3>

//   <h4 style={{marginTop:'10px', marginLeft:'20px',lineHeight: '1.5'}}>Quality Management System (QMS) Support</h4>
//   <ul style={{marginLeft:'30px'}}>
//     <li>Setup and sustain QMS</li>
//     <li>Compliance with industry standards</li>
//   </ul>

//   <h4 style={{marginTop:'10px', marginLeft:'20px',lineHeight: '1.5'}}>Continuous Improvement Programs</h4>
//   <ul style={{marginLeft:'30px'}}>
//     <li>Yield optimization</li>
//     <li>Cost optimization</li>
//     <li>Monitoring Factory KPIs for better productivity</li>
//   </ul>
// </section>
//                                 {/* <h3 class="testmonial-title" style={{fontSize:'25px'}}>
//                                 Our Quality Management System (QMS) Support ensures the setup and sustainability of QMS to comply with industry standards, maintaining the highest level of quality across all processes. We focus on continuous improvement programs that drive yield optimization and cost optimization, while actively monitoring Factory KPIs to enhance productivity and operational efficiency.
//                                 </h3>
//                                 <div class="ak-height-50 ak-height-lg-30"></div> */}
//                                 {/* <div class="person-info">
//                                     <div>
//                                         <p class="name">Andrew Taylor</p>
//                                         <p class="form">From USA</p>
//                                     </div>
//                                     <div>
//                                         <svg xmlns="http://www.w3.org/2000/svg" width="43" height="38" viewBox="0 0 43 38" fill="none">
//                         <path
//                           d="M19.2291 14.229C19.2291 20.8709 17.6233 26.0703 14.4117 29.8272C11.2 33.5841 6.68822 36.0531 0.876244 37.2343V30.4171C5.28972 29.064 8.25971 26.6176 9.7862 23.078C10.6236 21.3935 10.9863 19.5127 10.8351 17.6376H0.548283L0.548283 0.39867L19.2291 0.39867V14.229ZM42.9883 14.229C42.9883 20.7836 41.4261 25.962 38.3018 29.7642C35.1775 33.5664 30.6221 36.0571 24.6354 37.2363V30.4191C29.0929 29.0193 32.0862 26.6159 33.6154 23.209C34.3942 21.4604 34.7318 19.5472 34.5983 17.6376L24.3075 17.6376V0.39867H42.9883L42.9883 14.229Z"
//                           fill="#485B60"
//                         />
//                       </svg>
//                                     </div>
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div class="testmonial-controller" style={{marginTop:'20px'}}>
//                     <div class="testmonial-swiper-controller">
//                         <button class="testmonial-next-btn slider-btn next">
//                 <svg
//                   width="10"
//                   height="18"
//                   viewBox="0 0 10 18"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </button>
//                         <button class="testmonial-prev-btn slider-btn prev">
//                 <svg
//                   width="10"
//                   height="18"
//                   viewBox="0 0 10 18"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
//                     stroke="#030917"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </button>
//                     </div>
//                     {/* <div>
//                         <p class="ak-black-color mb-0 ak-medium">350+ Over</p>
//                         <p class="ak-font-16 mb-0">User Feedback</p>
//                     </div> */}
//                 </div>
//             </div>
//         </div>
//     </section>
//     {/* <!-- End Testmonial --> */}

//     {/* <!-- Start Fun Fact Counter --> */}
//     {/* <div class="ak-height-135 ak-height-lg-80"></div> */}
//     <div class="funfact-counter" style={{marginTop:'40px'}}>
//         <div class="container">
//             <div class="funfact-inner">
//                 <div class="funfact-title-content ak-section-heading animation-title-content animation-style3">
//                     <h3 class="funfact-title ak-section-title">
//                         Our Extraordinary Achievement
//                     </h3>
//                 </div>
//                 <div class="auto-counter-section" id="counter">
//                     <div class="funfact style1">
//                         <div class="funfact-number color-1">
//                             <span class="counter">51</span>
//                             <span>+</span>
//                         </div>

//                         <div class="funfact-text">
//                             <p class="text">Trained Professionals</p>
//                         </div>
//                     </div>
//                     <div class="divider-border d-none d-xxl-inline">
//                         <svg xmlns="http://www.w3.org/2000/svg" width="38" height="121" viewBox="0 0 38 121" fill="none">
//                 <path
//                   opacity="0.1"
//                   d="M0.502868 120.342L37.2834 0.457802"
//                   stroke="#030917"
//                 />
//               </svg>
//                     </div>
//                     <div class="funfact style1">
//                         <div class="funfact-number color-1">
//                             <span class="counter">17</span>
//                             <span>+</span>
//                         </div>
//                         <div class="funfact-text">
//                             <p class="text">Years of Experience</p>
//                         </div>
//                     </div>
//                     <div class="divider-border d-none d-xxl-inline">
//                         <svg xmlns="http://www.w3.org/2000/svg" width="38" height="121" viewBox="0 0 38 121" fill="none">
//                 <path
//                   opacity="0.1"
//                   d="M0.502868 120.342L37.2834 0.457802"
//                   stroke="#030917"
//                 />
//               </svg>
//                     </div>
//                     <div class="funfact style1">
//                         <div class="funfact-number color-1">
//                             <span class="counter">21</span>
//                             <span>k</span>
//                         </div>
//                         <div class="funfact-text">
//                             <p class="text">Inspired Learners</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
//     {/* <!-- End Fun Fact Counter --> */}


//     {/* <!-- Start Video  --> */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
//     <div class="video-home ak-video-section" style={{marginTop:'40px'}}>
//         <img src="./assets/img/bg/hm9.png" class="parallax-bg" alt="..." />
//         <div class="container container-custom">
//             <div class="video-info-content">
//                 <a href="https://www.youtube.com/watch?v=VcaAVWtP48A" class="video-btn ak-video-block ak-style1 ak-video-open">
//                     <div class="cricle-btn"></div>
//                 </a>
//                 <div class="video-title-content">
//                     <h4 class="video-title" style={{fontSize:'40px'}}>
//                     Driving Excellence in Semiconductor Quality and Innovation
//                     </h4>
//                 </div>
//             </div>
//         </div>
//     </div>
//     {/* <!-- End Video --> */}

//     {/* <!-- Start Team --> */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
//     <section>
//         <div class="container">
//             <div class="ak-section-heading-content">
//                 <div class="ak-section-heading ak-style-1 animation-title-content animation-style3 ">
//                     <p class="ak-section-subtitle animation-title" style={{marginTop:'20px'}} >Mentor</p>
//                     <h3 class="ak-section-title animation-title" style={{fontSize:'40px'}}>
//                     Meet Our Expert Semiconductor Training Team
//                     </h3>
//                 </div>
//                 <div class="service-swiper-controller" style={{marginBottom:'-50px'}}>
//                     <button class="service-next-btn slider-btn next">
//               <svg
//                 width="10"
//                 height="18"
//                 viewBox="0 0 10 18"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
//                   stroke="#030917"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                 />
//               </svg>
//             </button>
//                     <button class="service-prev-btn slider-btn prev">
//               <svg
//                 width="10"
//                 height="18"
//                 viewBox="0 0 10 18"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
//                   stroke="#030917"
//                   stroke-linecap="round"
//                   stroke-linejoin="round"
//                 />
//               </svg>
//             </button>
//                 </div>
//             </div>
//             <div class="ak-height-60 ak-height-lg-50"></div>
//             <div class="ak-slider ak-team-slider">
//                 <div class="swiper-wrapper">
//                     <div class="swiper-slide">
//                         <div class="team-card h-100">
//                             <a href="/" class="team-thamnel">
//                   <img src="./assets/img/team/team_1.png" alt="..." />
//                   {/* <div class="team-card-btn">
//                     <span class="btn-text">View More</span>
//                     <span class="icon-arrow">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="13"
//                         height="12"
//                         viewBox="0 0 13 12"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                     </span>
//                   </div> */}
//                 </a>

//                             <div class="team-body">
//                                 <a href="/" class="team-info">
//                                     <h5 class="title">Michael Chen</h5>
//                                     <p class="short-title">Senior Financial Advisor</p>
//                                 </a>
//                                 <div class="boder-hr"></div>
//                                 <div class="socile-icon">
//                                     <a href="#">
//                       <svg
//                         width="8"
//                         height="15"
//                         viewBox="0 0 8 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M4.75132 14.2964L4.75132 7.9108H6.89384L7.21528 5.42148H4.75132V3.83242C4.75132 3.11193 4.95058 2.62092 5.98493 2.62092L7.302 2.62038V0.393848C7.07423 0.364248 6.29238 0.296387 5.38238 0.296387C3.48216 0.296387 2.18124 1.45626 2.18124 3.58588L2.18124 5.42148H0.0322266L0.0322266 7.9108H2.18124L2.18124 14.2964H4.75132Z"
//                           fill="#030917"
//                         />
//                       </svg>
//                     </a>

//                                     <a href="#">
//                       <svg
//                         width="14"
//                         height="15"
//                         viewBox="0 0 14 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <mask id="path-1-inside-1_122_6153432" fill="white">
//                           <path
//                             d="M8.45401 6.22443L13.5538 0.296387H12.3453L7.91717 5.44362L4.38046 0.296387H0.30127L5.64948 8.07992L0.30127 14.2964H1.50982L6.18601 8.86073L9.92105 14.2964H14.0002L8.45372 6.22443H8.45401ZM6.79875 8.1485L6.25686 7.37343L1.94527 1.20616H3.80153L7.28103 6.18335L7.82291 6.95841L12.3459 13.428H10.4896L6.79875 8.14879V8.1485Z"
//                           />
//                         </mask>
//                         <path
//                           d="M8.45401 6.22443L13.5538 0.296387H12.3453L7.91717 5.44362L4.38046 0.296387H0.30127L5.64948 8.07992L0.30127 14.2964H1.50982L6.18601 8.86073L9.92105 14.2964H14.0002L8.45372 6.22443H8.45401ZM6.79875 8.1485L6.25686 7.37343L1.94527 1.20616H3.80153L7.28103 6.18335L7.82291 6.95841L12.3459 13.428H10.4896L6.79875 8.14879V8.1485Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M8.45401 6.22443V7.22443H8.91286L9.2121 6.87659L8.45401 6.22443ZM13.5538 0.296387L14.3118 0.948546L15.7332 -0.703613H13.5538V0.296387ZM12.3453 0.296387V-0.703613H11.8864L11.5872 -0.355778L12.3453 0.296387ZM7.91717 5.44362L7.09298 6.00994L7.82837 7.0802L8.67525 6.09579L7.91717 5.44362ZM4.38046 0.296387L5.20465 -0.269924L4.90666 -0.703613H4.38046V0.296387ZM0.30127 0.296387V-0.703613H-1.59916L-0.522919 0.862702L0.30127 0.296387ZM5.64948 8.07992L6.40754 8.73211L6.90979 8.14832L6.47367 7.51361L5.64948 8.07992ZM0.30127 14.2964L-0.456792 13.6442L-1.87822 15.2964H0.30127V14.2964ZM1.50982 14.2964V15.2964H1.96866L2.26789 14.9485L1.50982 14.2964ZM6.18601 8.86073L7.0102 8.2944L6.2748 7.22417L5.42793 8.20857L6.18601 8.86073ZM9.92105 14.2964L9.09687 14.8627L9.39486 15.2964H9.92105V14.2964ZM14.0002 14.2964V15.2964H15.9007L14.8244 13.7301L14.0002 14.2964ZM8.45372 6.22443V5.22443H6.55326L7.62954 6.79076L8.45372 6.22443ZM6.79875 8.1485H7.79875V7.83359L7.61831 7.5755L6.79875 8.1485ZM6.25686 7.37343L5.43728 7.9464L5.4373 7.94643L6.25686 7.37343ZM1.94527 1.20616V0.206158H0.026019L1.1257 1.77913L1.94527 1.20616ZM3.80153 1.20616L4.62111 0.633196L4.32257 0.206158H3.80153V1.20616ZM7.28103 6.18335L6.46145 6.75631L6.46147 6.75634L7.28103 6.18335ZM7.82291 6.95841L8.64249 6.38544L8.64247 6.38542L7.82291 6.95841ZM12.3459 13.428V14.428H14.2651L13.1654 12.855L12.3459 13.428ZM10.4896 13.428L9.67003 14.001L9.96857 14.428H10.4896V13.428ZM6.79875 8.14879H5.79875V8.4637L5.97918 8.72178L6.79875 8.14879ZM9.2121 6.87659L14.3118 0.948546L12.7957 -0.355772L7.69593 5.57227L9.2121 6.87659ZM13.5538 -0.703613H12.3453V1.29639H13.5538V-0.703613ZM11.5872 -0.355778L7.1591 4.79146L8.67525 6.09579L13.1034 0.948552L11.5872 -0.355778ZM8.74137 4.87731L5.20465 -0.269924L3.55626 0.862697L7.09298 6.00994L8.74137 4.87731ZM4.38046 -0.703613H0.30127V1.29639H4.38046V-0.703613ZM-0.522919 0.862702L4.82529 8.64624L6.47367 7.51361L1.12546 -0.269929L-0.522919 0.862702ZM4.89142 7.42774L-0.456792 13.6442L1.05933 14.9486L6.40754 8.73211L4.89142 7.42774ZM0.30127 15.2964H1.50982V13.2964H0.30127V15.2964ZM2.26789 14.9485L6.94409 9.51289L5.42793 8.20857L0.751736 13.6442L2.26789 14.9485ZM5.36183 9.42705L9.09687 14.8627L10.7452 13.7301L7.0102 8.2944L5.36183 9.42705ZM9.92105 15.2964H14.0002V13.2964H9.92105V15.2964ZM14.8244 13.7301L9.2779 5.65811L7.62954 6.79076L13.1761 14.8627L14.8244 13.7301ZM8.45372 7.22443H8.45401V5.22443H8.45372V7.22443ZM7.61831 7.5755L7.07642 6.80044L5.4373 7.94643L5.97919 8.72149L7.61831 7.5755ZM7.07644 6.80046L2.76485 0.633186L1.1257 1.77913L5.43728 7.9464L7.07644 6.80046ZM1.94527 2.20616H3.80153V0.206158H1.94527V2.20616ZM2.98194 1.77912L6.46145 6.75631L8.10061 5.61038L4.62111 0.633196L2.98194 1.77912ZM6.46147 6.75634L7.00336 7.5314L8.64247 6.38542L8.10059 5.61035L6.46147 6.75634ZM7.00334 7.53138L11.5263 14.001L13.1654 12.855L8.64249 6.38544L7.00334 7.53138ZM12.3459 12.428H10.4896V14.428H12.3459V12.428ZM11.3092 12.855L7.61831 7.57581L5.97918 8.72178L9.67003 14.001L11.3092 12.855ZM7.79875 8.14879V8.1485H5.79875V8.14879H7.79875Z"
//                           fill="#030917"
//                           mask="url(#path-1-inside-1_122_6153432)"
//                         />
//                       </svg>
//                     </a>
//                                     <a href="#">
//                       <svg
//                         width="14"
//                         height="15"
//                         viewBox="0 0 14 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M10.2103 0.296387H3.78967C1.70001 0.296387 0 1.9964 0 4.08605V10.5068C0 12.5964 1.70001 14.2964 3.78967 14.2964H10.2104C12.3 14.2964 14 12.5964 14 10.5068V4.08605C14 1.9964 12.3 0.296387 10.2103 0.296387ZM13.1792 10.5068C13.1792 12.1438 11.8474 13.4756 10.2103 13.4756H3.78967C2.15257 13.4756 0.820738 12.1438 0.820738 10.5068V4.08605C0.820738 2.44896 2.15257 1.11712 3.78967 1.11712H10.2104C11.8474 1.11712 13.1792 2.44896 13.1792 4.08605V10.5068Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M6.99989 3.46826C4.88908 3.46826 3.17188 5.18547 3.17188 7.29627C3.17188 9.40708 4.88908 11.1243 6.99989 11.1243C9.11069 11.1243 10.8279 9.40708 10.8279 7.29627C10.8279 5.18547 9.11069 3.46826 6.99989 3.46826ZM6.99989 10.3035C5.34175 10.3035 3.99261 8.95452 3.99261 7.29627C3.99261 5.63813 5.34175 4.289 6.99989 4.289C8.65813 4.289 10.0072 5.63813 10.0072 7.29627C10.0072 8.95452 8.65813 10.3035 6.99989 10.3035Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M10.9197 2.1084C10.2959 2.1084 9.78857 2.61586 9.78857 3.23953C9.78857 3.86331 10.2959 4.37077 10.9197 4.37077C11.5435 4.37077 12.0509 3.86331 12.0509 3.23953C12.0509 2.61575 11.5435 2.1084 10.9197 2.1084ZM10.9197 3.54992C10.7486 3.54992 10.6093 3.41064 10.6093 3.23953C10.6093 3.06831 10.7486 2.92914 10.9197 2.92914C11.0909 2.92914 11.2302 3.06831 11.2302 3.23953C11.2302 3.41064 11.0909 3.54992 10.9197 3.54992Z"
//                           fill="#030917"
//                         />
//                       </svg>
//                     </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div class="swiper-slide">
//                         <div class="team-card h-100">
//                             <a href="/" class="team-thamnel">
//                   <img src="./assets/img/team/team_2.png" alt="..." />
//                   {/* <div class="team-card-btn">
//                     <span class="btn-text">View More</span>
//                     <span class="icon-arrow">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="13"
//                         height="12"
//                         viewBox="0 0 13 12"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                     </span>
//                   </div> */}
//                 </a>

//                             <div class="team-body">
//                                 <a href="/" class="team-info">
//                                     <h5 class="title">Matthew Thompson</h5>
//                                     <p class="short-title">Investment Analyst</p>
//                                 </a>
//                                 <div class="boder-hr"></div>
//                                 <div class="socile-icon">
//                                     <a href="#">
//                       <svg
//                         width="8"
//                         height="15"
//                         viewBox="0 0 8 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M4.75132 14.2964L4.75132 7.9108H6.89384L7.21528 5.42148H4.75132V3.83242C4.75132 3.11193 4.95058 2.62092 5.98493 2.62092L7.302 2.62038V0.393848C7.07423 0.364248 6.29238 0.296387 5.38238 0.296387C3.48216 0.296387 2.18124 1.45626 2.18124 3.58588L2.18124 5.42148H0.0322266L0.0322266 7.9108H2.18124L2.18124 14.2964H4.75132Z"
//                           fill="#030917"
//                         />
//                       </svg>
//                     </a>

//                                     <a href="#">
//                       <svg
//                         width="14"
//                         height="15"
//                         viewBox="0 0 14 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <mask id="path-1-inside-1_122_615asd" fill="white">
//                           <path
//                             d="M8.45401 6.22443L13.5538 0.296387H12.3453L7.91717 5.44362L4.38046 0.296387H0.30127L5.64948 8.07992L0.30127 14.2964H1.50982L6.18601 8.86073L9.92105 14.2964H14.0002L8.45372 6.22443H8.45401ZM6.79875 8.1485L6.25686 7.37343L1.94527 1.20616H3.80153L7.28103 6.18335L7.82291 6.95841L12.3459 13.428H10.4896L6.79875 8.14879V8.1485Z"
//                           />
//                         </mask>
//                         <path
//                           d="M8.45401 6.22443L13.5538 0.296387H12.3453L7.91717 5.44362L4.38046 0.296387H0.30127L5.64948 8.07992L0.30127 14.2964H1.50982L6.18601 8.86073L9.92105 14.2964H14.0002L8.45372 6.22443H8.45401ZM6.79875 8.1485L6.25686 7.37343L1.94527 1.20616H3.80153L7.28103 6.18335L7.82291 6.95841L12.3459 13.428H10.4896L6.79875 8.14879V8.1485Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M8.45401 6.22443V7.22443H8.91286L9.2121 6.87659L8.45401 6.22443ZM13.5538 0.296387L14.3118 0.948546L15.7332 -0.703613H13.5538V0.296387ZM12.3453 0.296387V-0.703613H11.8864L11.5872 -0.355778L12.3453 0.296387ZM7.91717 5.44362L7.09298 6.00994L7.82837 7.0802L8.67525 6.09579L7.91717 5.44362ZM4.38046 0.296387L5.20465 -0.269924L4.90666 -0.703613H4.38046V0.296387ZM0.30127 0.296387V-0.703613H-1.59916L-0.522919 0.862702L0.30127 0.296387ZM5.64948 8.07992L6.40754 8.73211L6.90979 8.14832L6.47367 7.51361L5.64948 8.07992ZM0.30127 14.2964L-0.456792 13.6442L-1.87822 15.2964H0.30127V14.2964ZM1.50982 14.2964V15.2964H1.96866L2.26789 14.9485L1.50982 14.2964ZM6.18601 8.86073L7.0102 8.2944L6.2748 7.22417L5.42793 8.20857L6.18601 8.86073ZM9.92105 14.2964L9.09687 14.8627L9.39486 15.2964H9.92105V14.2964ZM14.0002 14.2964V15.2964H15.9007L14.8244 13.7301L14.0002 14.2964ZM8.45372 6.22443V5.22443H6.55326L7.62954 6.79076L8.45372 6.22443ZM6.79875 8.1485H7.79875V7.83359L7.61831 7.5755L6.79875 8.1485ZM6.25686 7.37343L5.43728 7.9464L5.4373 7.94643L6.25686 7.37343ZM1.94527 1.20616V0.206158H0.026019L1.1257 1.77913L1.94527 1.20616ZM3.80153 1.20616L4.62111 0.633196L4.32257 0.206158H3.80153V1.20616ZM7.28103 6.18335L6.46145 6.75631L6.46147 6.75634L7.28103 6.18335ZM7.82291 6.95841L8.64249 6.38544L8.64247 6.38542L7.82291 6.95841ZM12.3459 13.428V14.428H14.2651L13.1654 12.855L12.3459 13.428ZM10.4896 13.428L9.67003 14.001L9.96857 14.428H10.4896V13.428ZM6.79875 8.14879H5.79875V8.4637L5.97918 8.72178L6.79875 8.14879ZM9.2121 6.87659L14.3118 0.948546L12.7957 -0.355772L7.69593 5.57227L9.2121 6.87659ZM13.5538 -0.703613H12.3453V1.29639H13.5538V-0.703613ZM11.5872 -0.355778L7.1591 4.79146L8.67525 6.09579L13.1034 0.948552L11.5872 -0.355778ZM8.74137 4.87731L5.20465 -0.269924L3.55626 0.862697L7.09298 6.00994L8.74137 4.87731ZM4.38046 -0.703613H0.30127V1.29639H4.38046V-0.703613ZM-0.522919 0.862702L4.82529 8.64624L6.47367 7.51361L1.12546 -0.269929L-0.522919 0.862702ZM4.89142 7.42774L-0.456792 13.6442L1.05933 14.9486L6.40754 8.73211L4.89142 7.42774ZM0.30127 15.2964H1.50982V13.2964H0.30127V15.2964ZM2.26789 14.9485L6.94409 9.51289L5.42793 8.20857L0.751736 13.6442L2.26789 14.9485ZM5.36183 9.42705L9.09687 14.8627L10.7452 13.7301L7.0102 8.2944L5.36183 9.42705ZM9.92105 15.2964H14.0002V13.2964H9.92105V15.2964ZM14.8244 13.7301L9.2779 5.65811L7.62954 6.79076L13.1761 14.8627L14.8244 13.7301ZM8.45372 7.22443H8.45401V5.22443H8.45372V7.22443ZM7.61831 7.5755L7.07642 6.80044L5.4373 7.94643L5.97919 8.72149L7.61831 7.5755ZM7.07644 6.80046L2.76485 0.633186L1.1257 1.77913L5.43728 7.9464L7.07644 6.80046ZM1.94527 2.20616H3.80153V0.206158H1.94527V2.20616ZM2.98194 1.77912L6.46145 6.75631L8.10061 5.61038L4.62111 0.633196L2.98194 1.77912ZM6.46147 6.75634L7.00336 7.5314L8.64247 6.38542L8.10059 5.61035L6.46147 6.75634ZM7.00334 7.53138L11.5263 14.001L13.1654 12.855L8.64249 6.38544L7.00334 7.53138ZM12.3459 12.428H10.4896V14.428H12.3459V12.428ZM11.3092 12.855L7.61831 7.57581L5.97918 8.72178L9.67003 14.001L11.3092 12.855ZM7.79875 8.14879V8.1485H5.79875V8.14879H7.79875Z"
//                           fill="#030917"
//                           mask="url(#path-1-inside-1_122_615asd)"
//                         />
//                       </svg>
//                     </a>
//                                     <a href="#">
//                       <svg
//                         width="14"
//                         height="15"
//                         viewBox="0 0 14 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M10.2103 0.296387H3.78967C1.70001 0.296387 0 1.9964 0 4.08605V10.5068C0 12.5964 1.70001 14.2964 3.78967 14.2964H10.2104C12.3 14.2964 14 12.5964 14 10.5068V4.08605C14 1.9964 12.3 0.296387 10.2103 0.296387ZM13.1792 10.5068C13.1792 12.1438 11.8474 13.4756 10.2103 13.4756H3.78967C2.15257 13.4756 0.820738 12.1438 0.820738 10.5068V4.08605C0.820738 2.44896 2.15257 1.11712 3.78967 1.11712H10.2104C11.8474 1.11712 13.1792 2.44896 13.1792 4.08605V10.5068Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M6.99989 3.46826C4.88908 3.46826 3.17188 5.18547 3.17188 7.29627C3.17188 9.40708 4.88908 11.1243 6.99989 11.1243C9.11069 11.1243 10.8279 9.40708 10.8279 7.29627C10.8279 5.18547 9.11069 3.46826 6.99989 3.46826ZM6.99989 10.3035C5.34175 10.3035 3.99261 8.95452 3.99261 7.29627C3.99261 5.63813 5.34175 4.289 6.99989 4.289C8.65813 4.289 10.0072 5.63813 10.0072 7.29627C10.0072 8.95452 8.65813 10.3035 6.99989 10.3035Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M10.9197 2.1084C10.2959 2.1084 9.78857 2.61586 9.78857 3.23953C9.78857 3.86331 10.2959 4.37077 10.9197 4.37077C11.5435 4.37077 12.0509 3.86331 12.0509 3.23953C12.0509 2.61575 11.5435 2.1084 10.9197 2.1084ZM10.9197 3.54992C10.7486 3.54992 10.6093 3.41064 10.6093 3.23953C10.6093 3.06831 10.7486 2.92914 10.9197 2.92914C11.0909 2.92914 11.2302 3.06831 11.2302 3.23953C11.2302 3.41064 11.0909 3.54992 10.9197 3.54992Z"
//                           fill="#030917"
//                         />
//                       </svg>
//                     </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div class="swiper-slide">
//                         <div class="team-card h-100">
//                             <a href="/" class="team-thamnel">
//                   <img src="./assets/img/team/team_3.png" alt="..." />
//                   {/* <div class="team-card-btn">
//                     <span class="btn-text">View More</span>
//                     <span class="icon-arrow">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="13"
//                         height="12"
//                         viewBox="0 0 13 12"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                     </span>
//                   </div> */}
//                 </a>

//                             <div class="team-body">
//                                 <a href="/" class="team-info">
//                                     <h5 class="title">David Rodriguez</h5>
//                                     <p class="short-title">Planning Specialist</p>
//                                 </a>
//                                 <div class="boder-hr"></div>
//                                 <div class="socile-icon">
//                                     <a href="#">
//                       <svg
//                         width="8"
//                         height="15"
//                         viewBox="0 0 8 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M4.75132 14.2964L4.75132 7.9108H6.89384L7.21528 5.42148H4.75132V3.83242C4.75132 3.11193 4.95058 2.62092 5.98493 2.62092L7.302 2.62038V0.393848C7.07423 0.364248 6.29238 0.296387 5.38238 0.296387C3.48216 0.296387 2.18124 1.45626 2.18124 3.58588L2.18124 5.42148H0.0322266L0.0322266 7.9108H2.18124L2.18124 14.2964H4.75132Z"
//                           fill="#030917"
//                         />
//                       </svg>
//                     </a>

//                                     <a href="#">
//                       <svg
//                         width="14"
//                         height="15"
//                         viewBox="0 0 14 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <mask id="path-1-inside-1_122_615324234" fill="white">
//                           <path
//                             d="M8.45401 6.22443L13.5538 0.296387H12.3453L7.91717 5.44362L4.38046 0.296387H0.30127L5.64948 8.07992L0.30127 14.2964H1.50982L6.18601 8.86073L9.92105 14.2964H14.0002L8.45372 6.22443H8.45401ZM6.79875 8.1485L6.25686 7.37343L1.94527 1.20616H3.80153L7.28103 6.18335L7.82291 6.95841L12.3459 13.428H10.4896L6.79875 8.14879V8.1485Z"
//                           />
//                         </mask>
//                         <path
//                           d="M8.45401 6.22443L13.5538 0.296387H12.3453L7.91717 5.44362L4.38046 0.296387H0.30127L5.64948 8.07992L0.30127 14.2964H1.50982L6.18601 8.86073L9.92105 14.2964H14.0002L8.45372 6.22443H8.45401ZM6.79875 8.1485L6.25686 7.37343L1.94527 1.20616H3.80153L7.28103 6.18335L7.82291 6.95841L12.3459 13.428H10.4896L6.79875 8.14879V8.1485Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M8.45401 6.22443V7.22443H8.91286L9.2121 6.87659L8.45401 6.22443ZM13.5538 0.296387L14.3118 0.948546L15.7332 -0.703613H13.5538V0.296387ZM12.3453 0.296387V-0.703613H11.8864L11.5872 -0.355778L12.3453 0.296387ZM7.91717 5.44362L7.09298 6.00994L7.82837 7.0802L8.67525 6.09579L7.91717 5.44362ZM4.38046 0.296387L5.20465 -0.269924L4.90666 -0.703613H4.38046V0.296387ZM0.30127 0.296387V-0.703613H-1.59916L-0.522919 0.862702L0.30127 0.296387ZM5.64948 8.07992L6.40754 8.73211L6.90979 8.14832L6.47367 7.51361L5.64948 8.07992ZM0.30127 14.2964L-0.456792 13.6442L-1.87822 15.2964H0.30127V14.2964ZM1.50982 14.2964V15.2964H1.96866L2.26789 14.9485L1.50982 14.2964ZM6.18601 8.86073L7.0102 8.2944L6.2748 7.22417L5.42793 8.20857L6.18601 8.86073ZM9.92105 14.2964L9.09687 14.8627L9.39486 15.2964H9.92105V14.2964ZM14.0002 14.2964V15.2964H15.9007L14.8244 13.7301L14.0002 14.2964ZM8.45372 6.22443V5.22443H6.55326L7.62954 6.79076L8.45372 6.22443ZM6.79875 8.1485H7.79875V7.83359L7.61831 7.5755L6.79875 8.1485ZM6.25686 7.37343L5.43728 7.9464L5.4373 7.94643L6.25686 7.37343ZM1.94527 1.20616V0.206158H0.026019L1.1257 1.77913L1.94527 1.20616ZM3.80153 1.20616L4.62111 0.633196L4.32257 0.206158H3.80153V1.20616ZM7.28103 6.18335L6.46145 6.75631L6.46147 6.75634L7.28103 6.18335ZM7.82291 6.95841L8.64249 6.38544L8.64247 6.38542L7.82291 6.95841ZM12.3459 13.428V14.428H14.2651L13.1654 12.855L12.3459 13.428ZM10.4896 13.428L9.67003 14.001L9.96857 14.428H10.4896V13.428ZM6.79875 8.14879H5.79875V8.4637L5.97918 8.72178L6.79875 8.14879ZM9.2121 6.87659L14.3118 0.948546L12.7957 -0.355772L7.69593 5.57227L9.2121 6.87659ZM13.5538 -0.703613H12.3453V1.29639H13.5538V-0.703613ZM11.5872 -0.355778L7.1591 4.79146L8.67525 6.09579L13.1034 0.948552L11.5872 -0.355778ZM8.74137 4.87731L5.20465 -0.269924L3.55626 0.862697L7.09298 6.00994L8.74137 4.87731ZM4.38046 -0.703613H0.30127V1.29639H4.38046V-0.703613ZM-0.522919 0.862702L4.82529 8.64624L6.47367 7.51361L1.12546 -0.269929L-0.522919 0.862702ZM4.89142 7.42774L-0.456792 13.6442L1.05933 14.9486L6.40754 8.73211L4.89142 7.42774ZM0.30127 15.2964H1.50982V13.2964H0.30127V15.2964ZM2.26789 14.9485L6.94409 9.51289L5.42793 8.20857L0.751736 13.6442L2.26789 14.9485ZM5.36183 9.42705L9.09687 14.8627L10.7452 13.7301L7.0102 8.2944L5.36183 9.42705ZM9.92105 15.2964H14.0002V13.2964H9.92105V15.2964ZM14.8244 13.7301L9.2779 5.65811L7.62954 6.79076L13.1761 14.8627L14.8244 13.7301ZM8.45372 7.22443H8.45401V5.22443H8.45372V7.22443ZM7.61831 7.5755L7.07642 6.80044L5.4373 7.94643L5.97919 8.72149L7.61831 7.5755ZM7.07644 6.80046L2.76485 0.633186L1.1257 1.77913L5.43728 7.9464L7.07644 6.80046ZM1.94527 2.20616H3.80153V0.206158H1.94527V2.20616ZM2.98194 1.77912L6.46145 6.75631L8.10061 5.61038L4.62111 0.633196L2.98194 1.77912ZM6.46147 6.75634L7.00336 7.5314L8.64247 6.38542L8.10059 5.61035L6.46147 6.75634ZM7.00334 7.53138L11.5263 14.001L13.1654 12.855L8.64249 6.38544L7.00334 7.53138ZM12.3459 12.428H10.4896V14.428H12.3459V12.428ZM11.3092 12.855L7.61831 7.57581L5.97918 8.72178L9.67003 14.001L11.3092 12.855ZM7.79875 8.14879V8.1485H5.79875V8.14879H7.79875Z"
//                           fill="#030917"
//                           mask="url(#path-1-inside-1_122_615324234)"
//                         />
//                       </svg>
//                     </a>
//                                     <a href="#">
//                       <svg
//                         width="14"
//                         height="15"
//                         viewBox="0 0 14 15"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M10.2103 0.296387H3.78967C1.70001 0.296387 0 1.9964 0 4.08605V10.5068C0 12.5964 1.70001 14.2964 3.78967 14.2964H10.2104C12.3 14.2964 14 12.5964 14 10.5068V4.08605C14 1.9964 12.3 0.296387 10.2103 0.296387ZM13.1792 10.5068C13.1792 12.1438 11.8474 13.4756 10.2103 13.4756H3.78967C2.15257 13.4756 0.820738 12.1438 0.820738 10.5068V4.08605C0.820738 2.44896 2.15257 1.11712 3.78967 1.11712H10.2104C11.8474 1.11712 13.1792 2.44896 13.1792 4.08605V10.5068Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M6.99989 3.46826C4.88908 3.46826 3.17188 5.18547 3.17188 7.29627C3.17188 9.40708 4.88908 11.1243 6.99989 11.1243C9.11069 11.1243 10.8279 9.40708 10.8279 7.29627C10.8279 5.18547 9.11069 3.46826 6.99989 3.46826ZM6.99989 10.3035C5.34175 10.3035 3.99261 8.95452 3.99261 7.29627C3.99261 5.63813 5.34175 4.289 6.99989 4.289C8.65813 4.289 10.0072 5.63813 10.0072 7.29627C10.0072 8.95452 8.65813 10.3035 6.99989 10.3035Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M10.9197 2.1084C10.2959 2.1084 9.78857 2.61586 9.78857 3.23953C9.78857 3.86331 10.2959 4.37077 10.9197 4.37077C11.5435 4.37077 12.0509 3.86331 12.0509 3.23953C12.0509 2.61575 11.5435 2.1084 10.9197 2.1084ZM10.9197 3.54992C10.7486 3.54992 10.6093 3.41064 10.6093 3.23953C10.6093 3.06831 10.7486 2.92914 10.9197 2.92914C11.0909 2.92914 11.2302 3.06831 11.2302 3.23953C11.2302 3.41064 11.0909 3.54992 10.9197 3.54992Z"
//                           fill="#030917"
//                         />
//                       </svg>
//                     </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </section>

//     {/* <!-- End Team --> */}
// {/* 
//     <!-- Start Strategic --> */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div>
//     <section class="container-xxl" id="strategicCard">
//         <div class="strategic-card-content">
//             <div class="strategic" data-src="./assets/img/bg/strategic-bg.png">
//                 <div class="strategic-info">
//                     <div class="ak-section-heading ak-style-1">
//                         <p class="ak-section-subtitle animation-title">Strategic</p>
//                         <h2 class="ak-section-title title-anim">
//                             Strategic Investment Plan Tailored to Your Goals
//                         </h2>
//                     </div>
//                     <div class="ak-height-50 ak-height-lg-30"></div>
//                     <div class="personalized-long-term">
//                         <div class="personalized">
//                             <img class="icon" src="./assets/img/icon/target.svg" alt="..." />
//                             <h5 class="title">Personalized Strategies</h5>
//                             <p class="desp">
//                                 Personalized financial plans tailored to individual or business needs.
//                             </p>
//                         </div>
//                         <div class="personalized-divder"></div>
//                         <div class="long-term">
//                             <img class="icon" src="./assets/img/icon/line-chart.svg" alt="..." />
//                             <h5 class="title">Personalized Strategies</h5>
//                             <p class="desp">
//                                 Personalized financial plans tailored to individual or business needs.
//                             </p>
//                         </div>
//                     </div>
//                     <div class="ak-height-50 ak-height-lg-30"></div>
//                     <a href="contact.html" class="common-btn">
//               <span> Get Started</span>
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="15"
//                   height="15"
//                   viewBox="0 0 15 15"
//                   fill="none"
//                 >
//                   <g clip-path="url(#clip0_201_978321290)">
//                     <path
//                       d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                       stroke="#030917"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_201_978321290">
//                       <rect
//                         width="14"
//                         height="14"
//                         fill="white"
//                         transform="translate(0.00927734)"
//                       />
//                     </clipPath>
//                   </defs>
//                 </svg>
//               </span>
//             </a>
//                 </div>
//                 <div class="strategic-img">
//                     <img src="./assets/img/strategic/sticky-1.png" alt="..." />
//                 </div>
//             </div>
//             <div class="strategic style-2 ak-secondary-bg" data-src="./assets/img/bg/strategic-bg.png">
//                 <div class="strategic-info">
//                     <div class="ak-section-heading ak-style-1 color-2 animation-style4">
//                         <p class="ak-section-subtitle animation-title">
//                             Retirement Solutions
//                         </p>
//                         <h2 class="ak-section-title title-anim">
//                             Secure Future Tailored Retirement Solutions
//                         </h2>
//                         <p class="ak-section-desp">
//                             Experts help clients navigate retirement planning challenges
//                         </p>
//                     </div>
//                     <div class="ak-height-50 ak-height-lg-30"></div>
//                     <div class="atd-skills">
//                         <div class="atd-skill">
//                             <div class="atd-circle color-2" data-percentage="85">
//                                 <div class="atd-circle-mini">
//                                     <div class="percentage"><span>85%</span></div>
//                                 </div>
//                             </div>
//                             <div class="atd-skill-text">
//                                 <h6 class="title ak-white-color">Income</h6>
//                                 <p class="desp ak-white-color">Assessment</p>
//                             </div>
//                         </div>
//                         <div class="atd-skill">
//                             <div class="atd-circle color-2" data-percentage="65">
//                                 <div class="atd-circle-mini">
//                                     <div class="percentage"><span>65%</span></div>
//                                 </div>
//                             </div>
//                             <div class="atd-skill-text">
//                                 <h6 class="title ak-white-color">Tax Withdrawal</h6>
//                                 <p class="desp ak-white-color">Strategies</p>
//                             </div>
//                         </div>
//                     </div>
//                     <div class="ak-height-50 ak-height-lg-30"></div>
//                     <a href="contact.html" class="common-btn">
//               <span> Get Started</span>
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="15"
//                   height="15"
//                   viewBox="0 0 15 15"
//                   fill="none"
//                 >
//                   <g clip-path="url(#clip0_201_97821)">
//                     <path
//                       d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                       stroke="#030917"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_201_97821">
//                       <rect
//                         width="14"
//                         height="14"
//                         fill="white"
//                         transform="translate(0.00927734)"
//                       />
//                     </clipPath>
//                   </defs>
//                 </svg>
//               </span>
//             </a>
//                 </div>
//                 <div class="strategic-img">
//                     <img src="./assets/img/strategic/sticky-2.png" alt="..." />
//                 </div>
//             </div>
//             <div class="strategic" data-src="./assets/img/bg/strategic-bg.png">
//                 <div class="strategic-info">
//                     <div class="ak-section-heading ak-style-1">
//                         <p class="ak-section-subtitle animation-title">Tax Planning</p>
//                         <h2 class="ak-section-title title-anim">
//                             Wealth Strategic Tax Planning Solutions
//                         </h2>
//                     </div>
//                     <div class="ak-height-50 ak-height-lg-30"></div>
//                     <div class="ak-skill-box">
//                         <div class="ak-skill-text">
//                             <p class="ak-skill-title">Strategic Tax Minimization</p>
//                             <p class="ak-skill-per">95%</p>
//                         </div>
//                         <div class="ak-skill-bar">
//                             <div class="ak-skill-fill" data-percentage="95"></div>
//                         </div>
//                     </div>
//                     <div class="ak-skill-box">
//                         <div class="ak-skill-text">
//                             <p class="ak-skill-title">Long-Term Tax Efficiency</p>
//                             <p class="ak-skill-per">80%</p>
//                         </div>
//                         <div class="ak-skill-bar">
//                             <div class="ak-skill-fill" data-percentage="80"></div>
//                         </div>
//                     </div>
//                     <div class="ak-skill-box">
//                         <div class="ak-skill-text">
//                             <p class="ak-skill-title">Asset Location Optimization</p>
//                             <p class="ak-skill-per">65%</p>
//                         </div>
//                         <div class="ak-skill-bar">
//                             <div class="ak-skill-fill" data-percentage="65"></div>
//                         </div>
//                     </div>

//                     <div class="ak-height-50 ak-height-lg-30"></div>
//                     <a href="contact.html" class="common-btn">
//               <span> Get Started</span>
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="15"
//                   height="15"
//                   viewBox="0 0 15 15"
//                   fill="none"
//                 >
//                   <g clip-path="url(#clip0_201_97854456)">
//                     <path
//                       d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                       stroke="#030917"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_201_97854456">
//                       <rect
//                         width="14"
//                         height="14"
//                         fill="white"
//                         transform="translate(0.00927734)"
//                       />
//                     </clipPath>
//                   </defs>
//                 </svg>
//               </span>
//             </a>
//                 </div>
//                 <div class="strategic-img">
//                     <img src="./assets/img/strategic/sticky-3.png" alt="..." />
//                 </div>
//             </div>
//         </div>
//     </section> */}
//     {/* <!-- End Strategic --> */}

//     {/* <!-- Start Blog --> */}
//     {/* <div class="ak-height-50"></div>
//     <section>
//         <div class="container">
//             <div class="row g-5">
//                 <div class="col-lg-12 col-xl-4">
//                     <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
//                         <p class="ak-section-subtitle animation-title">Recent Blog</p>
//                         <h2 class="ak-section-title animation-title">
//                             Financial Insights and Inspiration
//                         </h2>
//                         <div class="ak-height-50 ak-height-lg-50"></div>
//                         <a href="blog-details.html" class="more-btn">
//                 <span> View All Blogs </span>
//                 <span class="svg-icon">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="18"
//                     height="19"
//                     viewBox="0 0 18 19"
//                     fill="none"
//                   >
//                     <path
//                       d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                       fill="#030917"
//                     />
//                     <path
//                       d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                       stroke="#030917"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="18"
//                     height="19"
//                     viewBox="0 0 18 19"
//                     fill="none"
//                   >
//                     <path
//                       d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                       fill="#030917"
//                     />
//                     <path
//                       d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                       stroke="#030917"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </span>
//               </a>
//                     </div>
//                 </div>
//                 <div class="col-lg-12 col-xl-8">
//                     <div class="blog-content style-1">
//                         <a href="blog-details.html" class="blog-card style-1">
//                 <img
//                   class="blog-hover-img"
//                   src="./assets/img/blog/blog-hover-1.png"
//                   alt="..."
//                 />
//                 <div class="blog-right">
//                   <p class="short-title">David Brown / 30-4-24</p>
//                   <h5 class="title">
//                     Navigating Financial Expert Advice from a Trusted Finance
//                     Advisor
//                   </h5>
//                 </div>
//                 <div class="blog-left">
//                   <div class="more-btn">
//                     <span>Read More</span>
//                     <span class="svg-icon">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                     </span>
//                   </div>
//                 </div>
//               </a>
//                         <a href="blog-details.html" class="blog-card style-1">
//                 <img
//                   class="blog-hover-img"
//                   src="./assets/img/blog/blog-hover-2.png"
//                   alt="..."
//                 />
//                 <div class="blog-right">
//                   <p class="short-title">Andrew Taylor / 30-4-24</p>
//                   <h5 class="title">
//                     Navigating Market Volatility Strategies for Success with Our
//                     Finance Advisors
//                   </h5>
//                 </div>
//                 <div class="blog-left">
//                   <div class="more-btn">
//                     <span>Read More</span>
//                     <span class="svg-icon">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                     </span>
//                   </div>
//                 </div>
//               </a>
//                         <a href="blog-details.html" class="blog-card style-1">
//                 <img
//                   class="blog-hover-img"
//                   src="./assets/img/blog/blog-hover-3.png"
//                   alt="..."
//                 />
//                 <div class="blog-right">
//                   <p class="short-title">Daniel Martinez / 30-4-24</p>
//                   <h5 class="title">
//                     Building a Secure Financial Future: Insights from Our
//                     Trusted Finance Advisors
//                   </h5>
//                 </div>
//                 <div class="blog-left">
//                   <div class="more-btn">
//                     <span>Read More</span>
//                     <span class="svg-icon">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                     </span>
//                   </div>
//                 </div>
//               </a>
//                         <a href="blog-details.html" class="blog-card style-1">
//                 <img
//                   class="blog-hover-img"
//                   src="./assets/img/blog/blog-hover-4.png"
//                   alt="..."
//                 />
//                 <div class="blog-right">
//                   <p class="short-title">Robert Garcia / 30-4-24</p>
//                   <h5 class="title">
//                     Mastering the Art of Wealth Management: Expert Tips from Our
//                     Finance Advisors
//                   </h5>
//                 </div>
//                 <div class="blog-left">
//                   <div class="more-btn">
//                     <span>Read More</span>
//                     <span class="svg-icon">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="18"
//                         height="19"
//                         viewBox="0 0 18 19"
//                         fill="none"
//                       >
//                         <path
//                           d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
//                           fill="#030917"
//                         />
//                         <path
//                           d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
//                           stroke="#030917"
//                           stroke-linecap="round"
//                           stroke-linejoin="round"
//                         />
//                       </svg>
//                     </span>
//                   </div>
//                 </div>
//               </a>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </section> */}
//     {/* <!-- End Blog --> */}


//     {/* <!-- Strat Contact --> */}
//     {/* <div class="ak-height-125 ak-height-lg-80"></div>
//     <div class="container-fluid px-md-0">
//         <div class="contact-form-content">
//             <div class="contact-form-img image-hov-one">
//                 <img src="./assets/img/contact/contact-img.png" alt="..." />
//             </div>
//             <div class="contact-form">
//                 <div>
//                     <h5 class="contact-title">
//                         Ready to take control of your financial future? Our team of seasoned experts is here to guide you every step of the way. Fill out the form below to get in touch with us today!
//                     </h5>
//                     <div class="ak-height-40 ak-height-lg-30"></div>
//                 </div>
//                 <form>
//                     <div class="form-inputs">
//                         <div class="type_1">
//                             <label for="fullname" class="form-label">Your Name</label>
//                             <input type="text" name="fullname" id="fullname" class="csame" placeholder="Write your name here..." />
//                         </div>
//                     </div>
//                     <div class="form-inputs">
//                         <div class="type_1">
//                             <label for="YourPhone" class="form-label">Your Phone</label>
//                             <input type="tel" name="phone" id="YourPhone" class="csame" placeholder="Write your phone number here..." />
//                         </div>
//                         <div class="type_1">
//                             <label for="emailInput" class="form-label">Your Email*</label>
//                             <input type="email" name="email" id="emailInput" class="csame" placeholder="Write your email here..." required />
//                         </div>
//                     </div>
//                     <div class="form-inputs">
//                         <div class="type_1">
//                             <label for="websiteInput" class="form-label">Website</label>
//                             <select name="website" id="websiteInput" class="csame">
//                   <option
//                     value=""
//                     disabled
//                     selected
//                     hidden
//                     class="select-placeholder"
//                   >
//                     Write your web address here...
//                   </option>
//                   <option value="1">Option 1</option>
//                   <option value="2">Option 2</option>
//                 </select>
//                         </div>
//                         <div class="type_1">
//                             <label for="budgetInput" class="form-label">Budget</label>
//                             <select name="budget" id="budgetInput" class="csame">
//                   <option
//                     value=""
//                     disabled
//                     selected
//                     hidden
//                     class="select-placeholder"
//                   >
//                     What is your budget...
//                   </option>
//                   <option value="1">Option 1</option>
//                   <option value="2">Option 2</option>
//                 </select>
//                         </div>
//                     </div>
//                     <div class="form-textarea">
//                         <div class="type_1">
//                             <label for="textareaInput" class="form-label">Description</label
//                 >
//                 <textarea
//                   name="description"
//                   rows="3"
//                   id="textareaInput"
//                   class="csame"
//                   placeholder="Write description details..."
//                 ></textarea>
//               </div>
//             </div>
//             <div class="ak-height-40 ak-height-lg-40"></div>
//             <button type="submit" class="common-btn border-0">
//               <span>Send Message</span>
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="15"
//                   height="15"
//                   viewBox="0 0 15 15"
//                   fill="none"
//                 >
//                   <g clip-path="url(#clip0_201_978343789)">
//                     <path
//                       d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
//                       stroke="#030917"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_201_978343789">
//                       <rect
//                         width="14"
//                         height="14"
//                         fill="white"
//                         transform="translate(0.00927734)"
//                       />
//                     </clipPath>
//                   </defs>
//                 </svg>
//               </span>
//             </button>
//           </form>
//         </div>
//       </div>
//     </div> */}
//     {/* <!-- End Contact --> */}
//  <span class="ak-scrollup">
//       <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
//           fill="currentColor"
//         />
//       </svg>
//     </span>
//     </div>
//   )
// }

// export default Home



import React from 'react';

const Home = () => {
  const services = [
    {
      id: 1,
      title: 'Short Term Courses',
      image: './assets/img/bg/hmd.png'
    },
    {
      id: 2,
      title: 'Semiconductor Finishing School',
      image: './assets/img/service/service_2.png'
    },
    {
      id: 3,
      title: 'Nurturing Wafer FAB & OSAT New Hires',
      image: './assets/img/bg/s71.png'
    },
    {
      id: 4,
      title: 'Semiconductor Services',
      image: './assets/img/bg/hm5.png'
    }
  ];

  return (
    <>

         <section className="ak-slider ak-slider-hero ak-slider-hero-1 swiper-fade">
<div className="swiper-wrapper" id="swiper-wrapper-6236af38e51ff0e3" aria-live="polite" style={{ transitionDuration: '0ms' }}>
  <div className="swiper-slide swiper-slide-duplicate swiper-slide-prev swiper-slide-duplicate-next" data-swiper-slide-index="1" style={{ width: '651px', transitionDuration: '0ms', opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }} role="group" aria-label="2 / 2"></div>
  
  <div className="swiper-slide swiper-slide-visible swiper-slide-active" data-swiper-slide-index="0" style={{ width: '651px', transitionDuration: '0ms', opacity: 1, transform: 'translate3d(-651px, 0px, 0px)' }} role="group" aria-label="1 / 2">
    <div className="ak-hero ak-style1 slide-inner" data-swiper-parallax="100%">
      <div className="ak-hero-featured" data-src="./assets/img/bg/bgh31.png" style={{ backgroundImage: 'url("./assets/img/bg/bgh31.png")' }}>
        <img src="./assets/img/bg/bgg.png" className="ak-hero-bg" alt="..." />
      </div>
      <div className="container-md">
        <div className="hero-slider-info">
          <div className="slider-info">
            <div className="hero-title">
              <p className="mini-title" style={{ color: 'white' }}>Welcome to Your Trusted Semiconductor Training Partner!</p>
              <br /><br />
              <p className="mini-title1" style={{ backgroundColor: 'rgb(232, 119, 34)', color: 'white', padding: '5px 10px', fontWeight: 'bold', display: 'inline-block', borderRadius: '5px' }}>SEMANTIC Skills Junction</p>
              <h6 className="hero-main-title responive_na" style={{ color: 'rgb(217, 173, 59)', fontWeight: 'bold' }}>
                Guidance from Industry Experts<br />
                <span className="hero-main-title-1 style-2" style={{ fontSize: '68px', color: 'white' }}></span>
              </h6>
              <p className="main-desp" style={{ color: 'white' }}>
                Building India's future as a global semiconductor leader with <br />
                <strong style={{ backgroundColor: 'black', borderRadius: '5px', padding: '2px 3px' }}>
                  {' '}<span style={{ color: 'rgb(232, 119, 34)' }}>SEM</span>iconductor <span style={{ color: 'rgb(232, 119, 34)' }}>MAN</span>ufacturing <span style={{ color: 'rgb(232, 119, 34)' }}>T</span>raining & <span style={{ color: 'rgb(13, 201, 20)' }}>I</span>ndustry <span style={{ color: 'rgb(13, 201, 20)' }}>C</span>onsultancy
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</section>

<div className="social-hero">
  <div className="content">
    <h6 className="email style-1" style={{ marginBottom: '-10px', fontSize: '17px' }}>(+91)7619617023</h6>
    <div className="hr style-1" style={{ marginTop: '10px', fontSize: '17px', marginBottom: '50px' }}></div>
    <h6 className="email style-1">sriram@semanticskills.com</h6>
  </div>
</div>


<div className="moving-section-wrap cs-bold">
  <div className="moving-section-in">
    <div className="moving-section">
      <h2 style={{ fontSize: '34px' }}>Empowering Semiconductor Career Paths -- Expert Training from Industry Leaders --</h2>
    </div>
  </div>
</div>

<section className="container" style={{ marginTop: '30px' }}>
  <div className="about-us-content">
    <div className="image-content">
      <img className="about-img-1" src="./assets/img/bg/hm3.png" alt="..." style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 2.8038px)' }} />
    </div>
    <div className="info-content">
      <div className="ak-section-heading ak-style-1 animation-title-content animation-style3" style={{ marginLeft: '-10px' }}>
        <p className="ak-section-subtitle animation-title" style={{ perspective: '400px' }}>About Us</p>
        <h2 className="ak-section-title animation-title" style={{ perspective: '400px' }}>Unlocking Global Talent Potential with Expert Training</h2>
        <p className="ak-section-desp" style={{ textAlign: 'justify' }}>
          At <span style={{ fontWeight: 'bold' }}>SEMANTIC</span>, we provide personalized training programs tailored to your unique career aspirations and the evolving needs of the semiconductor industry.
        </p>
        <p className="ak-section-desp" style={{ textAlign: 'justify' }}>
          With over 100 years of collective experience in the semiconductor industry, including 17 years spent at top international manufacturing plants, our leadership team brings unparalleled expertise to shape the future of global talent
        </p>
      </div>
      <br />
      <div>
        <ul className="points-list" style={{ textAlign: 'justify' }}>
          <li><strong>Tailored Programs:</strong> Custom training paths to suit individual career goals.</li>
          <li><strong>Industry Expertise:</strong> Leadership team with decades of experience at leading global manufacturing plants.</li>
          <li><strong>Real-World Skills:</strong> Training designed to equip professionals with skills for the evolving semiconductor industry.</li>
        </ul>
      </div>
    </div>
  </div>
</section>


<section className="container" style={{ marginTop: '30px' }}>
  <div className="feature-content">
    <div className="feature-card">
      <div className="feature-body">
        <h5 className="feature-title">Personalized Training Programs</h5>
        <p className="feature-desp" style={{ textAlign: 'justify' }}>
          SEMANTIC offers the customized training programs carefully designed to help individuals achieve their career aspirations in the semiconductor industry, ensuring they are equipped with the knowledge and skills required for success.
        </p>
      </div>
    </div>
    <div className="feature-card">
      <div className="feature-body">
        <h5 className="feature-title">Industry-Relevant Skill Development</h5>
        <p className="feature-desp" style={{ textAlign: 'justify' }}>
          Our programs emphasize the real-world applications, enabling professionals to acquire practical, hands-on skills that align with the dynamic demands of the rapidly evolving semiconductor industry.
        </p>
      </div>
    </div>
    <div className="feature-card">
      <div className="feature-body">
        <h5 className="feature-title">Clear Pathways to Career Growth</h5>
        <p className="feature-desp" style={{ textAlign: 'justify' }}>
          We provide the structured career development plans and offering step-by-step guidance to professionals, helping them achieve sustainable growth and long-term success in the semiconductor domain.
        </p>
      </div>
    </div>
  </div>
</section>


<section>
  <div className="container">
    <div className="service-top">
      <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
        <h4 className="ak-section-title animation-title" style={{ fontSize: '40px', perspective: '400px' }}>
          Shaping the Future of Global Semiconductor Talent and Innovative Industry Solutions
        </h4>
      </div>
      <div className="service-swiper-controller mb-2" style={{ marginLeft: '1100px', marginTop: '-40px' }}>
        <button className="service-next-btn slider-btn next" tabIndex="0" aria-label="Next slide">
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74" stroke="#030917" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button className="service-prev-btn slider-btn prev" tabIndex="0" aria-label="Previous slide">
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74" stroke="#030917" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
      </div>
    </div>
  </div>
</section>


<div className="service-bg">
  <div className="container">
    <div className="ak-slider ak-slider-service swiper-initialized swiper-horizontal swiper-pointer-events">
      <div className="swiper-wrapper" id="swiper-wrapper-10d1c8fca787f10a610" aria-live="polite" style={{ transitionDuration: '0ms', transform: 'translate3d(-2124px, 0px, 0px)' }}>
        <div className="swiper-slide swiper-slide-active" data-swiper-slide-index="0" role="group" aria-label="1 / 4" style={{ marginRight: '15px' }}>
          <div className="service-card h-100">
            <a  className="service-thumb">
              <img src="./assets/img/bg/hmd.png" alt="..." />
            </a>
            <div className="service-info">
              <a  className="service-title">Short Term Courses</a>
            </div>
          </div>
        </div>
        <div className="swiper-slide swiper-slide-active" data-swiper-slide-index="0" role="group" aria-label="1 / 4" style={{ marginRight: '15px' }}>
          <div className="service-card h-100">
            <a  className="service-thumb">
              <img src="./assets/img/service/service_2.png" alt="..." />
            </a>
            <div className="service-info">
              <a  className="service-title">Semiconductor Finishing School</a>
            </div>
          </div>
        </div>
        <div className="swiper-slide swiper-slide-active" data-swiper-slide-index="0" role="group" aria-label="1 / 4" style={{ marginRight: '15px' }}>
          <div className="service-card h-100">
            <a  className="service-thumb">
              <img src="./assets/img/bg/s71.png" alt="..." />
            </a>
            <div className="service-info">
              <a  className="service-title">Nurturing Wafer FAB & OSAT New Hires</a>
            </div>
          </div>
        </div>
        <div className="swiper-slide swiper-slide-active" data-swiper-slide-index="0" role="group" aria-label="1 / 4" style={{ marginRight: '15px' }}>
          <div className="service-card h-100">
            <a  className="service-thumb">
              <img src="./assets/img/bg/hm5.png" alt="..." />
            </a>
            <div className="service-info">
              <a  className="service-title">Nurturing OSAT New Hires</a>
              </div>
              </div>
              </div>
      </div>
    </div>
  </div>
</div>


<div className="funfact-counter" style={{ marginTop: '40px' }}>
  <div className="container">
    <div className="funfact-inner">
      <div className="funfact-title-content ak-section-heading animation-title-content animation-style3">
        <h3 className="funfact-title ak-section-title">Our Extraordinary Achievement</h3>
      </div>
      <div className="auto-counter-section" id="counter">
        <div className="funfact style1" style={{ translate: 'none', rotate: 'none', scale: 'none', opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }}>
          <div className="funfact-number color-1">
            <span className="counter">100</span>
            <span>+</span>
          </div>
          <div className="funfact-text">
            <p className="text">Trained Professionals</p>
          </div>
        </div>
        <div className="funfact style1" style={{ translate: 'none', rotate: 'none', scale: 'none', opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }}>
          <div className="funfact-number color-1">
            <span className="counter">20</span>
            <span>+</span>
          </div>
          <div className="funfact-text">
            <p className="text">years average Trainer experience</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div className="video-home ak-video-section" style={{ marginTop: '40px' }}>
  <img src="./assets/img/bg/hm9.png" className="parallax-bg" alt="..." style={{}} />
  <div className="container container-custom">
    <div className="video-info-content">
      <div className="video-title-content">
        <h4 className="video-title" style={{ fontSize: '40px' }}>
          <strong>
            {' '}<span style={{ color: 'rgb(232, 119, 34)' }}>SEM</span>iconductor <span style={{ color: 'rgb(232, 119, 34)' }}>MAN</span>ufacturing <span style={{ color: 'rgb(232, 119, 34)' }}>T</span>raining & <span style={{ color: 'rgb(13, 201, 20)' }}>I</span>ndustry <span style={{ color: 'rgb(13, 201, 20)' }}>C</span>onsultancy
          </strong>
        </h4>
      </div>
    </div>
  </div>
</div>


<div style={{ position: 'relative', display: 'inline-block', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(50px, 0px)', opacity: 0 }}>A</div>
<div className="split-line" style={{ display: 'block', textAlign: 'start', position: 'relative' }}>
  <div style={{ position: 'relative', display: 'inline-block' }}>
    <div style={{ position: 'relative', display: 'inline-block', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(50px, 0px)', opacity: 0 }}>U</div>
  </div>
</div></>
  );
};

export default Home;